import Vue from 'vue'

import Zh from '../lang/zh.js'
import En from '../lang/en.js'


// Vue.locale = () => {};
const changefun =  function(data) {
  let local=localStorage.getItem('locale')
  let nowlang={}
  let translated=''
      if(local=='en'){
        nowlang=En
      }else{
        nowlang=Zh
      }
      for(let key in nowlang){
        for(let bord in nowlang[key]){
          if(data==bord){
            translated=nowlang[key][bord]
          }
        }
      }

      return translated
}


// locale.i18n((key, value) => i18n.t(key, value));

export default changefun
